import { Controller } from 'stimulus';

export default class LoginCodeController extends Controller {
  static targets = ["input", "cells"]

  connect() {
    this.cells = Array.from(this.cellsTarget.children);
    // Native autofocus doesn't fire when this view loads inside a Turbo
    // Frame (e.g. the signup engine's turbo-frame swap), so focus explicitly.
    // Deferred a frame so document.activeElement is settled either way.
    requestAnimationFrame(() => {
      this.inputTarget.focus();
      this.syncCells();
    });
  }

  submit() {
    this.element.requestSubmit();
  }

  guardSubmit(e) {
    if (this.inputTarget.value.replace(/\D/g, '').length !== 6) {
      e.preventDefault();
    }
  }

  paste(e) {
    e.preventDefault();
    this.inputTarget.value = (e.clipboardData || window.clipboardData).getData('text');
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }

  input() {
    const value = this.inputTarget.value;
    const cleaned = value.replace(/\D/g, '').slice(0, 6);

    if (cleaned !== value) {
      this.inputTarget.value = cleaned;
    }

    this.syncCells();

    if (cleaned.length == 6) {
      this.submit();
    }
  }

  syncCells() {
    const value = this.inputTarget.value;
    const cells = this.cells;
    const focused = document.activeElement === this.inputTarget;

    cells.forEach((cell, i) => {
      cell.textContent = value[i] || "";

      if (focused && i === Math.min(value.length, cells.length - 1)) {
        cell.setAttribute('data-active', '');
      } else {
        cell.removeAttribute('data-active');
      }
    });
  }
}
